module.exports = __webpack_public_path__ + "img/human-mobile.0d8872d3.png";